// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--3sBQo";
export var inputGroupLg = "styles-module--input-group-lg--2i6WR";
export var techHeading = "styles-module--tech-heading--2xJTo";
export var techItem = "styles-module--tech-item--1i0MH";
export var subTitle = "styles-module--sub-title--1mNwy";